module.exports = __webpack_public_path__ + "static/media/5 degree error.662d04b6.jpg";